import script from "./manageGroupsSelectMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./manageGroupsSelectMenu.vue?vue&type=script&setup=true&lang=ts"

import "./manageGroupsSelectMenu.vue?vue&type=style&index=0&id=2fb45c07&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb45c07"]])

export default __exports__
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInfiniteScroll});
